"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
class Question extends base_model_1.default {
    constructor(data = {
        id: null,
        answer: null,
        wording: null,
        placeholder: null,
    }) {
        super(data);
        this.wording = defaults_1.defaultString(data.wording);
        this.answer = data.answer;
        this.placeholder = defaults_1.defaultString(data.placeholder);
    }
}
exports.default = Question;
